import type {
    CashRegisterConfig,
    CommonConfig,
    DepartmentConfig,
    DeviceConfig,
    MerchantConfig,
    MerchantDepartmentConfig,
} from "./types";

// COMMON
export const commonConfigDefault: Readonly<CommonConfig> = {
    welcomeMessage: "",
    printOrderWhenCompleted: false,
    logOutWhenCompleted: "no",
    language: "en",
    miscButtons: null,
    buttonLayout: null,
    paymentOptions: null,
    tableLayout: null,
    rotation: "0",
    autoDeleteOrderIdleTimeout: 0,
    autoDeleteOrderWarningTimeout: 0,
    warnOnRefundAndReturn: true,
    queryCustomersForData: false,
};

// MERCHANT & DEPARTMENT
export const merchantDepartmentConfig: Readonly<MerchantDepartmentConfig> = {
    address: "",
    zipcode: "",
    city: "",
    country: "",
    email: "",
    phone: "",
    cvr: "",
    headerText: "",
    footerText: "",
};

// MERCHANT
export const merchantConfigDefault: Readonly<MerchantConfig> = {
    ...commonConfigDefault,
    ...merchantDepartmentConfig,
    currency: "DKK",
    defaultVat: null,
    defaultDepartment: null,
    giftcardVatBookkeepingMethod: "AT_ISSUE",
    barcodeOnReceipt: true,
};

// DEPARTMENT
export const departmentConfigDefault: Readonly<DepartmentConfig> = {
    ...commonConfigDefault,
    ...merchantDepartmentConfig,
};

// CASH REGISTER
export const cashRegisterConfigDefault: Readonly<CashRegisterConfig> = {
    receiptPrinter: null,
    ticketPrinter: null,
    ...commonConfigDefault,
};

// DEVICE
export const deviceConfigDefault: Readonly<DeviceConfig> = {
    ...merchantConfigDefault,
    ...departmentConfigDefault,
    ...cashRegisterConfigDefault,
};
